import React from "react";
import { ReactComponent as Bootstrap5 } from "../../helper/svgicon/skills/Bootstrap5.svg";
import { ReactComponent as Chakra } from "../../helper/svgicon/skills/Chakra.svg";
import { ReactComponent as Css3 } from "../../helper/svgicon/skills/Css3.svg";
import { ReactComponent as Express } from "../../helper/svgicon/skills/Express.svg";
import { ReactComponent as Html } from "../../helper/svgicon/skills/Html.svg";
import { ReactComponent as Javascript } from "../../helper/svgicon/skills/Javascript.svg";
import { ReactComponent as Material } from "../../helper/svgicon/skills/Material.svg";
import { ReactComponent as Mongodb } from "../../helper/svgicon/skills/Mongodb.svg";
import { ReactComponent as Mongoose } from "../../helper/svgicon/skills/Mongoose.svg";
import { ReactComponent as Nodejs } from "../../helper/svgicon/skills/Nodejs.svg";
import { ReactComponent as Postman } from "../../helper/svgicon/skills/Postman.svg";
import { ReactComponent as Reactjs } from "../../helper/svgicon/skills/React.svg";
import { ReactComponent as Redux } from "../../helper/svgicon/skills/Redux.svg";
import { ReactComponent as Sass } from "../../helper/svgicon/skills/Sass.svg";
const ProjectTechnologyIcons = (props) => {
     return (
          <>
               {props.icon === "node" && <Nodejs />}
               {props.icon === "express" && <Express />}
               {props.icon === "mongodb" && <Mongodb />}
               {props.icon === "mongoose" && <Mongoose />}
               {props.icon === "postman" && <Postman />}
               {props.icon === "postman" && <Postman />}
               {props.icon === "react" && <Reactjs />}
               {props.icon === "redux" && <Redux />}
               {props.icon === "javascript" && <Javascript />}
               {props.icon === "html" && <Html />}
               {props.icon === "css" && <Css3 />}
               {props.icon === "sass" && <Sass />}
               {props.icon === "material" && <Material />}
               {props.icon === "bootstrap" && <Bootstrap5 />}
               {props.icon === "chakra" && <Chakra />}
          </>
     );
};

export default ProjectTechnologyIcons;
